import { Box, Dialog, Typography, useMediaQuery, useTheme } from '@mui/material'
import ActionButtons from '../../../components/action-buttons/action-buttons.component'
import { useSelector } from 'react-redux'
import { RootState } from 'store'
import {
  useDeleteEquipmentMutation,
  useListEquipmentsQuery,
} from 'store/equipments/equipments.api'
import { EquipmentResponse } from 'store/equipments/equipments.types'

type Props = {
  open: boolean
  handleClose: () => void
  equipment?: EquipmentResponse
}

const EquipmentDeleteDialog = ({ open, handleClose, equipment }: Props) => {
  const theme = useTheme()
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'))

  const [deleteEquipment] = useDeleteEquipmentMutation()
  const { refetch } = useListEquipmentsQuery()

  const selectedEquipment = useSelector(
    (state: RootState) => state.equipments.selectedEquipment
  )
  const equipmentToDelete = equipment ?? selectedEquipment

  const handleCancel = () => {
    handleClose()
  }

  const handleDelete = async () => {
    if (!equipmentToDelete?.equipmentId) return

    try {
      await deleteEquipment(equipmentToDelete.equipmentId.toString()).unwrap()
      handleClose()
      refetch()
    } catch (error) {
      console.error('Error while deleting equipment', error)
    }
  }

  return (
    <Dialog
      fullScreen={fullScreen}
      open={open}
      onClose={handleClose}
      fullWidth
      maxWidth="sm"
    >
      <Box textAlign="center">
        <Typography fontWeight={700} px={1} py={4}>
          Are you sure you want to delete the{' '}
          {equipmentToDelete?.equipmentType?.toLowerCase() || 'equipment'}?
        </Typography>
        <ActionButtons
          firstBtnProps={{
            title: 'Cancel',
            onClick: handleCancel,
            bgcolor: 'secondary.main',
          }}
          secondBtnProps={{ title: 'Delete', onClick: handleDelete }}
        />
      </Box>
    </Dialog>
  )
}

export default EquipmentDeleteDialog
